import WorkshopComponent from './WorkshopComponent';
import { WorkshopStepProps } from './WorkshopStep';
import SkillsMentoring from '../Visualizations/SkillsMentoring';
import Skills from '../Skills/Skills';

import { useEffect, useState } from 'react';
import { apiUrl } from '../../config/api';
import axios from 'axios';
import React from 'react';

import { useAuth } from '../../contexts/AuthContext';
import { TeamMember } from '../TeamMembers/TeamMembers';

async function saveSkills(teamMember: TeamMember, skills: string) {
  teamMember.skills = skills;
  await axios.put(apiUrl(`/api/team-members/${teamMember.id}`), teamMember)
}

// TODO: Skills are not displayed nor can be edited.
const SkillsMentoringWorkshop: React.FC = () => {
    const { currentTeam } = useAuth()
    const [teamMember, setTeamMember] = useState<TeamMember | null>(null);
    const [skills, setSkills] = useState<string>('');  // Destructure the context value
    const [teamMemberId, setTeamMemberId] = useState<number | null>(null);

    useEffect(() => {
      const fetchTeamMemberId = async () => {
        const response = await axios.get(apiUrl(`/api/auth/me`));

        setTeamMemberId(response.data.teams.filter((team: any) => team.id === currentTeam?.id)[0]?.membership_id)
      };
      fetchTeamMemberId();
    }, [currentTeam]);

    useEffect(() => {
      const fetchSkills = async () => {
        console.log('fetchSkills triggered with teamMemberId:', teamMemberId);
        if (!teamMemberId) {
          console.log('No teamMemberId, skipping skills fetch');
          return;
        }
        
        try {
          const res = await axios.get(apiUrl(`/api/team-members/${teamMemberId}`));
          console.log('Skills response:', res.data);
          setTeamMember(res.data);
          setSkills(res.data?.skills || '');
        } catch (error) {
          console.error('Error fetching skills:', error);
        }
      };
      fetchSkills();
    }, [teamMemberId]);


    const handleSkillChange = (newSkills: string) => {
        setSkills(newSkills);
        if (teamMember) {
            saveSkills(teamMember, newSkills);
        }
    }



const steps: WorkshopStepProps[] = [
    {
      title: 'Update your skills',
      number: 1,
      children: <Skills skills={skills} setSkills={handleSkillChange} />,
      canProceed: skills.length > 0,
      onContinue: () => {
        if (teamMember) {
          saveSkills(teamMember, skills);
        }
      }
    },
    {
      title: 'Explore mentoring opportunities',
      number: 2,
      children: <SkillsMentoring title="Explore mentoring opportunities" />,
      canProceed: false,
    },
  ];


  return (
    <WorkshopComponent title="Skills Mentoring" steps={steps} />
  );
};
export default SkillsMentoringWorkshop;


